import DropdownOptionItem from "../ui/dropdown-option-item";
import NavNewPageItem from "../ui/nav-new-page-item";
import { useState, useContext, useRef } from "react";
import TableContext from "../../contexts/table-context";
import SideBarContext from "../../contexts/side-bar-context";
import SidebarDropdown from "../ui/sidebar-dropdown";
import { useRouter } from 'next/router';
import { useTranslations } from "next-intl";
import Production from "./production";
import Staging from "./staging";

const CreateNewTable = ({ toggleCreate }) => {
    const triggerRef = useRef(null);
    const { createTable } = useContext(TableContext);
    const { toggleSideBar } = useContext(SideBarContext);
    const [isOpen, setIsOpen] = useState(false);
    const router = useRouter();
    const isFeatureEnabled = router.query.enable === 'all'
    const t = useTranslations('nav');
    const tTable = useTranslations('table');

    const tableTranslations = {
        columns: {
            task: tTable('columns.task'),
            status: tTable('columns.status'),
            assignedTo: tTable('columns.assignedTo'),
            text: tTable('columns.text'),
            name: tTable('columns.name'),
            objectives: tTable('columns.objectives'),
            keyResults: tTable('columns.keyResults')
        },
        statusOptions: {
            toDo: tTable('statusOptions.toDo'),
            inProgress: tTable('statusOptions.inProgress'),
            done: tTable('statusOptions.done')
        },
        names: {
            kanban: tTable('names.kanban'),
            untitledTable: tTable('names.untitledTable'),
            untitledDocument: tTable('names.untitledDocument'),
            okrs: tTable('names.okrs'),
            newFolder: tTable('names.newFolder')
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }
    const types = [
        { name: "Blank Table", type: "blank", available: true, icon: "table" },
        { name: "Kanban", type: "kanban", available: true, icon: "kanban" },
        { name: "Page", type: "document", available: true, icon: "file-text", tag: "Unstable" },
        { name: "OKRs", type: "okrs", available: true, icon: "list-collapse" },
        // { name: "Payroll", type: "payroll", available: false, icon:"banknote" },
        // { name: "Generate using AI", type: "ai", available: false, icon: "sparkles" },
    ];

    return (
        <>
            {/* <Production> */}
            <div ref={triggerRef} className="relative z-">
                <NavNewPageItem isOpen={isOpen} onClick={toggleDropdown} icon="plus">{t('newPage')}</NavNewPageItem>
                <SidebarDropdown triggerRef={triggerRef} position="right" isOpen={isOpen} toggleDropdown={toggleDropdown} additionalclasses='!left-[22px] lg:!left-[240px]' >
                    {types.map((type, index) => (
                        <div key={type.type}>
                            {/* {index === types.length - 1 && <div className="border-t-[1px] custom-border-grey-50 my-[4px]"></div>} */}
                            <DropdownOptionItem
                                onClick={() => {
                                    createTable(type.type, null, null, null, tableTranslations); toggleDropdown();
                                    if (window.innerWidth < 1024) {
                                        toggleSideBar();
                                    }
                                }}
                                isDisabled={!type.available}
                                tag={type.tag}
                                toggleDropdown={toggleDropdown}
                                icon={type.icon}
                            >
                                {type.name}
                            </DropdownOptionItem>
                        </div>
                    ))}
                    <DropdownOptionItem onClick={() => { toggleCreate(); toggleDropdown(); }} icon='folder'>Folder</DropdownOptionItem>
                </SidebarDropdown>
            </div>
            {/* </Production> */}
            {/* <Staging>
                <div ref={triggerRef} className="relative z-">
                    <NavNewPageItem isOpen={isOpen} onClick={toggleDropdown} secondaryIcon={isOpen ? 'chevron-up' : 'chevron-down'} icon="plus">{t('createNew')}</NavNewPageItem>
                    <div
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                            }`}
                    >
                        <div className="w-[80%] mx-auto ">
                            {types.map((type, index) => (
                                <div key={type.type}>
                                    <DropdownOptionItem
                                        onClick={() => {
                                            createTable(type.type, null, null, null, tableTranslations); toggleDropdown();
                                            if (window.innerWidth < 1024) {
                                                toggleSideBar();
                                            }
                                        }}
                                        isDisabled={!type.available}
                                        tag={type.tag}
                                        toggleDropdown={toggleDropdown}
                                        icon={type.icon}
                                    >
                                        {type.name}
                                    </DropdownOptionItem>
                                </div>
                            ))}
                            <DropdownOptionItem onClick={() => { toggleCreate(); toggleDropdown(); }} icon='folder'>Folder</DropdownOptionItem>
                        </div>
                    </div>
                </div>
            </Staging> */}
        </>
    );
};

export default CreateNewTable;